import { Component } from "react";
import * as Mousetrap from "mousetrap";

import { IHotkey } from "./IHotkey";

export interface IHotkeyBindingProps {
    hotkey: IHotkey;
}

export class HotkeyBinding extends Component<IHotkeyBindingProps> {
    public componentDidMount() {
        Mousetrap.bind(this.props.hotkey.code, this.onHotkey);
    }

    public componentWillUnmount() {
        const { code } = this.props.hotkey;
        Mousetrap.unbind(code);
    }

    public render() {
        return false;
    }

    private onHotkey = (e: Mousetrap.ExtendedKeyboardEvent): void => {
        e.preventDefault();
        const { onHotkey, context } = this.props.hotkey;
        onHotkey(context);
    };
}
